import { render, staticRenderFns } from "./subsidiaryOrderList.vue?vue&type=template&id=195acaaa&scoped=true&"
import script from "./subsidiaryOrderList.vue?vue&type=script&lang=js&"
export * from "./subsidiaryOrderList.vue?vue&type=script&lang=js&"
import style0 from "./subsidiaryOrderList.vue?vue&type=style&index=0&id=195acaaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195acaaa",
  null
  
)

component.options.__file = "subsidiaryOrderList.vue"
export default component.exports